








































import { Vue, Component } from 'vue-property-decorator';
import TransactionService from '@/services/TransactionService';

const transactionService = new TransactionService();

@Component
export default class TopGainerSection extends Vue {
  public topGainer: Array<any> = [];

  async created() {
    const { data } = await transactionService.getTopGainer();
    this.topGainer = [...data];
  }
}
